import React from 'react';
import { Container, styled, Flex, css } from '@goodrx/matisse';
import AppLogo from 'app/components/AppLogo/AppLogo';
import { mediaMaxWidth } from 'app/lib/utils';
import { SignInCta } from 'app/components/auth/SignUp/SignInCta/SignInCta';

const Header = styled.header`
  display: flex;
  align-items: center;
  height: 60px;
  flex-shrink: 0;

  ${mediaMaxWidth({
    sm: css`
      height: 48px;
    `,
  })}

  ${(p) => {
    return css`
      background: ${p.theme.colors.white};
      color: ${p.theme.colors.greyDarkest};
      border-bottom: 1px solid ${p.theme.colors.greyLight};
      margin-bottom: 32px;

      ${mediaMaxWidth({
        sm: css`
          margin-bottom: 0;
          border-bottom: none;
        `,
      })}
    `;
  }};
`;

const Wrapper = styled(Flex)`
  justify-content: space-between;

  ${mediaMaxWidth({
    sm: css`
      justify-content: center;
    `,
  })}
`;

const HideOnMobile = styled.div`
  display: flex;
  align-items: center;
  ${mediaMaxWidth({
    sm: `display: none;`,
  })}
`;

export const RegistrationHeader = () => {
  return (
    <>
      <Header>
        <Container>
          <Wrapper>
            <AppLogo />
            <HideOnMobile>
              <SignInCta />
            </HideOnMobile>
          </Wrapper>
        </Container>
      </Header>
    </>
  );
};
